/**
 * Little Boudoir — barre d'achat collante (mobile).
 *
 * 1. La barre ne s'affiche que lorsque le vrai bouton d'ajout est sorti de l'écran,
 *    pour ne pas doublonner avec lui au premier écran.
 * 2. Le prix suit les changements de variante : Dawn REMPLACE le contenu du conteneur
 *    #price-… (destination.innerHTML = source.innerHTML), donc on observe le conteneur
 *    et non le nœud .price-item, qui est détruit à chaque changement.
 */
(function () {
  function init(root) {
    var bar = (root || document).querySelector('.lb-sticky-atc');
    if (!bar || bar.dataset.lbReady === '1') return;
    bar.dataset.lbReady = '1';

    var btn = bar.querySelector('[data-sticky-atc]');
    var priceOut = bar.querySelector('[data-lb-sticky-price]');

    // Globo reconstruit la zone d'achat après le chargement (le bouton d'ajout devient un
    // gpo-clone-atc-button, et le formulaire est re-rendu). Un IntersectionObserver posé une
    // fois resterait accroché à un nœud détaché et ne se déclencherait plus jamais : on
    // re-interroge donc le DOM à chaque frame de défilement (coût négligeable, throttle rAF).
    var BUY_SELECTOR = 'product-form button[name="add"], .product-form__submit, button[name="add"]';
    var findBuyZone = function () {
      return document.querySelector(BUY_SELECTOR) || document.querySelector('product-form, .product-form');
    };

    if (btn) {
      btn.addEventListener('click', function () {
        var target = findBuyZone();
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ---- Visibilité : la barre n'apparaît que si la zone d'achat est hors écran ---- */
    var show = function (on) { bar.classList.toggle('is-visible', on); };
    var ticking = false;

    var update = function () {
      ticking = false;
      var el = findBuyZone();
      if (!el) {
        // Repli sans aucune dépendance au balisage : au-delà d'un écran de défilement.
        show(window.scrollY > window.innerHeight * 0.8);
        return;
      }
      var r = el.getBoundingClientRect();
      show(!(r.bottom > 0 && r.top < window.innerHeight));
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
    // Globo/Judge.me modifient la hauteur de la page après coup : on re-mesure.
    window.addEventListener('load', update);
    setTimeout(update, 1500);

    /* ---- Miroir du prix ---- */
    if (!priceOut) return;
    var priceBox = document.querySelector('.product__info-container [id^="price-"]')
                || document.querySelector('.product__info-container .price');
    if (!priceBox) return;

    var sync = function () {
      var node = priceBox.querySelector('.price-item--sale, .price-item--regular, .price-item');
      var t = node && (node.textContent || '').trim();
      if (t) priceOut.textContent = t;
    };
    sync();
    new MutationObserver(sync).observe(priceBox, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Éditeur de thème : la section est re-rendue à chaque modification.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
